import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=427047c1"
import script from "./TemplateManagement.vue?vue&type=script&lang=ts"
export * from "./TemplateManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports